module.exports = __webpack_public_path__ + "static/VRE-3c704574f36322426a90cd156c194fa2.png";